import React from "react"
import Styles from "./backDrop.module.css"

const BackDrop = props => {
  return <div className={Styles.backDrop} onClick={props.click}></div>
}

export default BackDrop
